<template>
  <div>
    <section>
      <picture>
        <img class="img-head"
             :src="require('@/assets/designKit/head.jpg')"
             alt=""
        >
      </picture>
    </section>
    <b-container fluid>
      <texts />
      <toasters />
      <badges />
      <buttons />
      <tooltips />
      <dividers />
      <formElements />
      <navbars />
      <taggeds />
      <listItems />
      <tabs />
      <cards />
      <white-box-card />
      <popups />
      <icons />
    </b-container>
  </div>
</template>
<script>

export default {
  name: 'DesignKit',
  components: {
    texts: () => import('./designKit/Text.vue'),
    toasters: () => import('./designKit/Toaster.vue'),
    badges: () => import('./designKit/Badge.vue'),
    buttons: () => import('./designKit/Button.vue'),
    tooltips: () => import('./designKit/Tooltip.vue'),
    dividers: () => import('./designKit/Divider.vue'),
    formElements: () => import('./designKit/FormElement.vue'),
    navbars: () => import('./designKit/Navbar.vue'),
    taggeds: () => import('./designKit/Tagged.vue'),
    listItems: () => import('./designKit/listItem.vue'),
    tabs: () => import('./designKit/Tab.vue'),
    cards: () => import('./designKit/Card.vue'),
    whiteBoxCard: () => import('./designKit/WhiteBoxCard.vue'),
    popups: () => import('./designKit/Popup.vue'),
    icons: () => import('./designKit/Icon.vue'),
  },
  computed: {},
  created() {
    this.testHtml();
  },
  methods: {
    testHtml() {
      return document.querySelectorAll('html')[0].innerHTML;
    },
  },
};
</script>
